export default __webpack_public_path__ + "static/media/icon858white.ebd50ff9.svg";